import { NO_GROWTH_BOOK_TEST } from '~/shared/constants/commonConstants'

export const getCurrentOnboardingVariant = (
  growthBookVariantId: string,
): string => `ab_variant_${growthBookVariantId || NO_GROWTH_BOOK_TEST}`
